import params from './params'
import removedComponents from './removed-components'
import supportedActions from './supported-actions'

export default { params, removedComponents, supportedActions }
